export default class ExpectedNetworkError extends Error {}
